import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="approval--website-email"
export default class extends Controller {
  static targets = ["email", "website"];

  connect() {
    this.handle({ target: this.websiteTarget });
  }

  handle({ target }) {
    this.emailTarget.innerHTML = `@${target.value}`;
  }
}
